import { createAsyncThunk } from "@reduxjs/toolkit";
import asyncInstance from "config/AsyncInstance";
import apiInstance from "config/axiosInstance";
import apiInstanceInternal from "config/axiosInstanceInternal";

export const GetAllClaimStatus = createAsyncThunk(
  "claim/GetAllClaimStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.post("allstatusList", {
        status_type: "claim",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllClaimType = createAsyncThunk(
  "claim/GetAllClaimType",
  async (_, { rejectWithValue }) => {
    try {
      const response = await asyncInstance.get("claimtypeList");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllClaimsList = createAsyncThunk(
  "claim/GetAllClaimsList",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/claimList", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const CreateSingleClaim = createAsyncThunk(
  "claim/CreateSingleClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/claimCreate", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const ClaimBatchCheck = createAsyncThunk(
  "claim/ClaimBatchCheck",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/claimbatchCheck",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const ViewClaim = createAsyncThunk(
  "claim/ViewClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/claimStatus", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const CreateClaimFromPreauth = createAsyncThunk(
  "claim/ViewClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/claimfrmPreauth",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetClaimRequest = createAsyncThunk(
  "claim/GetClaimRequest",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstanceInternal.get(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetClaimResponse = createAsyncThunk(
  "claim/GetClaimResponse",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstanceInternal.get(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetClaimCancelResponse = createAsyncThunk(
  "claim/GetClaimCancelResponse",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstanceInternal.get(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetClaimEligibility = createAsyncThunk(
  "claim/GetClaimEligibility",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstanceInternal.get(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetClaimPreauthorization = createAsyncThunk(
  "claim/GetClaimPreauthorization",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstanceInternal.get(body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetPrepareClaimService = createAsyncThunk(
  "claim/GetPrepareClaimService",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/preauthorizationtoclaimList",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const CancelClaim = createAsyncThunk(
  "claim/CancelClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/claimCancel", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const GetAllHistoryLog = createAsyncThunk(
  "claim/GetAllHistoryLog",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/claimHistory", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const DownloadRequestClaim = createAsyncThunk(
  "claim/DownloadRequestClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/claimreqDownload",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const DownloadResponseClaim = createAsyncThunk(
  "claim/DownloadResponseClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/claimrespDownload",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const WidthDrownDeleteClaim = createAsyncThunk(
  "claim/WidthDrownDeleteClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/claimchngStatus",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const MultipleCancelClaim = createAsyncThunk(
  "claim/MultipleCancelClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/claimmultiCancel",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const ResubmitClaim = createAsyncThunk(
  "claim/ResubmitClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/claimreSubmit", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const MultipleResubmitClaim = createAsyncThunk(
  "claim/MultipleResubmitClaim",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/claimmultireSubmit",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const SubmitClaimIndividualMulti = createAsyncThunk(
  "claim/SubmitClaimIndividualMulti",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/claimmultiSubmit",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CreateClaimCommunication = createAsyncThunk(
  "claim/CreateClaimCommunication",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/communicationclaimCreate",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const GetAllClaimCommunications = createAsyncThunk(
  "claim/GetAllClaimCommunications",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/communicationclaimList",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CreateGssReports = createAsyncThunk(
  "claim/CreateGssReports",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("reports/gssreport", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CreateTaxInvoiceReports = createAsyncThunk(
  "claim/CreateTaxInvoiceReports",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("reports/invoicereport", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const ClaimSecondResponse = createAsyncThunk(
  "claim/ClaimSecondResponse",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        "insurance/claimsecResponse",
        body
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const CreateMultipleClaimFromExcel = createAsyncThunk(
  "claim/CreateMultipleClaimFromExcel",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/claimimpCreate", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);


export const ViewClaimResponseHistoryLog = createAsyncThunk(
  "claim/ViewClaimResponseHistoryLog",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("insurance/claimhistoryView", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const ClaimDeleteReport = createAsyncThunk(
  "claim/ClaimDeleteReport",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("reports/claimdelReport", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
export const ClaimServiceReport = createAsyncThunk(
  "claim/ClaimServiceReport",
  async (body, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post("reports/claimserviceReport", body);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);